// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88c1787d","488":"db88a5bf","553":"4d943f7a","977":"38f4d6ca"}[chunkId] + ".chunk.js";
};